<template>
    <div class="view">
        <ul class="article_list">
            <li v-for="item in articleList"
                @click="$router.push('/ArticleInit/detail?articleId=' + item.articleId + '&articleModel=' + item.articleModel)">
                <div class="title">{{ item.articleTitle }}</div>
                <div class="date_time">{{ item.createTimeString }}</div>
            </li>
        </ul>
        <div class="page">
            <el-pagination layout="prev, pager, next" :total="total" @current-change="pageChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { apiService, RESULT_CODE } from "@/api/ApiService.js"
export default {
    name: 'ArticleList',
    data() {
        return {
            articleList: [],
            articleModel: '',
            total: 0,
            isHomePage: '0'
        }
    },
    mounted() {
        this.init()
    },
    watch: { '$route': 'init' },
    methods: {
        pageChange(pageNum) {
            let articleModel = this.articleModel
            let isHomePage = this.isHomePage
            apiService.findArticle({ articleModel, isHomePage, pageSize: 10, pageNum }).then(res => {
                this.articleList = res.rows
                this.total = res.total
            })
        },
        init() {
            let { articleModel } = this.$route.query
            let { isHomePage } = this.$route.query
            this.articleModel = articleModel
            this.isHomePage = isHomePage
            apiService.findArticle({ articleModel, isHomePage, pageSize: 10, pageNum: 1 }).then(res => {
                this.articleList = res.rows
                this.total = res.total
            })
        }
    }
}
</script>
<style scoped>
.view {
    width: 100%;
    margin-top: 0.05rem;
    background-color: #fff;
    padding: 0.1rem 0;
    user-select: none;
}

.article_list>li {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    line-height: 0.225rem;
    border-bottom: 1px dashed #ccc;
    padding: 0 0.15rem;
    font-size: 0.08rem;
    cursor: pointer;
    position: relative;
}

.article_list>li::before {
    content: '';
    position: absolute;
    width: 0.05rem;
    height: 0.05rem;
    background-color: #000;
    border-radius: 50%;
    left: 0.05rem;
    top: 50%;
    transform: translatey(-50%);
}

.article_list .title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.article_list .date_time {
    padding-left: 0.1rem;
    width: 0.75rem;
}
</style>


// WEBPACK FOOTER //
// src/components/ArticleList.vue